import React from 'react';

import Spinner from 'components/shared/Spinner';

class MainHeading extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-8">
            <h1 className="m-0">
              {this.props.icon ? <i className={this.props.icon + ' mr-2'} /> : ''}
              {this.props.title}
            </h1>
            <p>{this.props.descr}</p>
          </div>
          <div className="col-4 text-right">
            {
              this.props.status && this.props.status.fetching ? (
                <div style={{fontSize: '20px'}}>
                  <Spinner message="attendere..." />
                </div>
              ) : ''
            }
          </div>
        </div>
      </div>
    );
  }
}

export default MainHeading;


// WEBPACK FOOTER //
// ./src/components/shared/MainHeading.js